"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.check = void 0;
const module_1 = require("./inference/module");
const util_1 = require("../util");
function check(ast) {
    try {
        const context = module_1.inferModule(ast);
        return util_1.success(context);
    }
    catch (e) {
        return util_1.failure(e.message);
    }
}
exports.check = check;
//# sourceMappingURL=index.js.map